import React from "react";
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Stack
} from "@mui/material";
import { GraphUser } from "../../../../../../utils/MsGraphApiCall";

interface SearchResultsListProps {
    results: GraphUser[];
    selectedUser: GraphUser | null;
    onUserSelect: (user: GraphUser) => void;
}

export const SearchResultsList: React.FC<SearchResultsListProps> = ({
    results,
    selectedUser,
    onUserSelect
}) => {
    if (results.length === 0) {
        return null;
    }

    return (
        <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                Search Results ({results.length})
            </Typography>
            <List sx={{
                maxHeight: 300,
                overflow: 'auto',
                border: '1px solid #e2e8f0',
                borderRadius: 1
            }}>
                {results.map((user) => (
                    <ListItem key={user.id} disablePadding>
                        <ListItemButton
                            selected={selectedUser?.id === user.id}
                            onClick={() => onUserSelect(user)}
                            sx={{
                                '&.Mui-selected': {
                                    backgroundColor: '#162346',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: '#1a2a52',
                                    }
                                }
                            }}
                        >
                            <ListItemText
                                primary={user.displayName}
                                secondary={
                                    <Stack component="span" spacing={0.5}>
                                        <Typography component="span" variant="body2">
                                            {user.mail}
                                        </Typography>
                                        {user.jobTitle && (
                                            <Typography component="span" variant="caption">
                                                {user.jobTitle}
                                                {user.department && ` • ${user.department}`}
                                            </Typography>
                                        )}
                                    </Stack>
                                }
                                secondaryTypographyProps={{
                                    sx: {
                                        color: selectedUser?.id === user.id ? 'rgba(255,255,255,0.7)' : 'text.secondary'
                                    }
                                }}
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};
